<template>
<ct-modal title="  "
    v-if="visible"
    @closed="closedModal">
    <div slot="body">
      <div class="form-title" style="margin-top: -5px">Score this lesson *</div>
      <star-rating
        :score.sync="formData.score"
        :showText="true"
        class="rating-block"
       >
      </star-rating>
      <div class="form-title">Difficulty *</div>
      <div class="slider-block">
          <span>Easy</span>
          <div class="slider-block-content">
            <v-slider
            :min="1"
            :max="5"
            v-model="formData.difficult"
            ></v-slider>
          </div>
          <span>Hard</span>
      </div>

      <div class="form-title">Teaching Flow *</div>
      <div class="slider-block">
          <span>Jammed</span>
          <div class="slider-block-content">
            <v-slider
            :min="1"
            :max="5"
              v-model="formData.smooth"
              ></v-slider>
          </div>
          <span>Smooth</span>
      </div>
      <div class="form-title">Teaching Speed *</div>
      <div class="slider-block">
          <span>Too slow</span>
          <div class="slider-block-content">
            <v-slider
            :min="1"
            :max="5"
              v-model="formData.rhythm"
              ></v-slider>
          </div>
          <span>Too fast</span>
      </div>
      <div class="form-title">Comment this lesson (Optional)</div>
      <div class="input-container">
          <textarea
            :maxlength="maxlength"
            v-model="formData.content"
            class="edit-input"
            placeholder="Any feeling or advise about this lesson?"
            rows="7">
          </textarea>
      </div>
      <div class="input-count-tip">
        <span class="input-count-tip--count">{{count}}</span>
        <span>/{{maxlength}}</span>
      </div>
    </div>
    <div slot="footer">
      <ct-button type="text_secondary_light" @click="closedModal">Cancel</ct-button>
      <ct-button
      type="primary"
      :disabled="disabledSubmitBtn"
      :isLoading="loading"
      @click="handleSubmit"
      >submit</ct-button>
    </div>
  </ct-modal>
</template>
<script>
import api from '@ca/api'
import StarRating from '@ca/components/Star'
import Slider from '@ca/components/Slider'

export default {
  name: 'PingfenModal',
  components: {
    'star-rating': StarRating,
    'v-slider': Slider
  },
  props: {
    visible: {
      type: Boolean
    },
    classId: Number,
    subclassId: Number,
    logined: Boolean
  },
  data () {
    return {
      pending: false,
      maxlength: 200,
      formData: {
        content: '',
        score: 0,
        difficult: 3,
        smooth: 3,
        rhythm: 3
      }
    }
  },
  watch: {
    content (value) {
      if (value && value.length && value.length > this.maxlength) {
        this.content = this.content.slice(0, this.maxlength)
      }
    }
  },
  computed: {
    count () {
      const content = this.formData.content.toString()
      return content.length
    },
    loading () {
      return this.pending
    },
    disabledSubmitBtn () {
      return this.formData.score === 0 || this.pending
    }
  },
  methods: {
    handleSubmit () {
      this.pending = true
      api.liveCreateFeedback({
        data: {
          class_id: this.classId,
          subclass_id: this.subclassId,
          ...this.formData
        }
      }).then(res => {
        this.pending = false
        if (res.data.code === 1) {
          this.closedModal()
          this.$toast({ message: 'Thank you for the feedback!', type: 'success', duration: 2000 })
        } else if (res.data.code === 90604) {
          this.$toast({ message: '不允许管理员评分', type: 'warning', duration: 2000 })
        } else {
          this.$toast({ message: res.data.error, type: 'warning', duration: 2000 })
        }
      }, () => {
        this.pending = false
      })
    },
    closedModal () {
      this.$emit('close')
    }
  },
  mounted () {
    if (!this.logined) {
      return false
    }
    api.liveGetFeedback({
      params: {
        class_id: this.classId,
        subclass_id: this.subclassId
      }
    }).then(res => {
      const { data } = res
      if (data && data.code === 1) {
        const { difficult, smooth, rhythm, content, score } = data.data
        this.formData = {
          content,
          score,
          difficult: difficult || 3,
          smooth: smooth || 3,
          rhythm: rhythm || 3
        }
      }
    })
  }
}
</script>
<style scoped lang="scss">
@import '@/styles/_varaible.scss';

$textColor: #A3B1BF;
.form-title{
    font-size:14px;
    font-family:SFProText-Medium,SFProText;
    font-weight:500;
    color:rgba(54,85,114,1);
    margin-bottom: 8px;
}
.rating-block{
    margin: 10px 0 35px;
}
.slider-block-content{
    width: 100%;
    max-width: 260px;
}
.slider-block{
  display: flex;
  justify-content: space-between;
  font-size:14px;
  font-family:SFProText-Medium,SFProText;
  font-weight:500;
  margin-bottom: 40px;
  > span {
     width: 78px;
  }
  > span:last-child{
    text-align: right;
  }
}
.edit-input{
  background-color: #fff;
  border-radius:2px;
  font-weight:400;
  color:$secondary;
  width: 100%;
  outline: none;
  resize: vertical;
  padding: 12px;
  font-size: inherit;
  border:1px solid rgba(218,224,229,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
</style>
